import { createContext } from 'react';
import type { ReactNode } from 'react';

import type { ProjectDashboardRevision } from '../projectDashboardTypes';

const defaultRevisionValue: ProjectDashboardRevision = {
  data: undefined,
  status: {
    loading: false,
    error: undefined,
    submitting_build: false,
  },
  isSteady: false,
};

export const RevisionContext = createContext<ProjectDashboardRevision>(defaultRevisionValue);

type RevisionProviderProps = {
  children: ReactNode;
  value: ProjectDashboardRevision;
};

export const RevisionProvider = ({ children, value }: RevisionProviderProps) => (
  <RevisionContext.Provider value={value}>
    {children}
  </RevisionContext.Provider>
);

export default RevisionProvider;
